/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BookmarksInputs */

const en_bookmarks = /** @type {(inputs: BookmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bookmarks`)
};

const es_bookmarks = /** @type {(inputs: BookmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcadores`)
};

const fr_bookmarks = /** @type {(inputs: BookmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signets`)
};

const de_bookmarks = /** @type {(inputs: BookmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesezeichen`)
};

const ja_bookmarks = /** @type {(inputs: BookmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブックマーク`)
};

const zh_bookmarks = /** @type {(inputs: BookmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`书签`)
};

const ar_bookmarks = /** @type {(inputs: BookmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإشارات المرجعية`)
};

const id_bookmarks = /** @type {(inputs: BookmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penanda`)
};

const it_bookmarks = /** @type {(inputs: BookmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segnalibri`)
};

const ru_bookmarks = /** @type {(inputs: BookmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закладки`)
};

const pt_bookmarks = /** @type {(inputs: BookmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favoritos`)
};

const ko_bookmarks = /** @type {(inputs: BookmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`북마크`)
};

/**
* | output |
* | --- |
* | "Bookmarks" |
*
* @param {BookmarksInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const bookmarks = /** @type {((inputs?: BookmarksInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BookmarksInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bookmarks(inputs)
	if (locale === "es") return es_bookmarks(inputs)
	if (locale === "fr") return fr_bookmarks(inputs)
	if (locale === "de") return de_bookmarks(inputs)
	if (locale === "ja") return ja_bookmarks(inputs)
	if (locale === "zh") return zh_bookmarks(inputs)
	if (locale === "ar") return ar_bookmarks(inputs)
	if (locale === "id") return id_bookmarks(inputs)
	if (locale === "it") return it_bookmarks(inputs)
	if (locale === "ru") return ru_bookmarks(inputs)
	if (locale === "pt") return pt_bookmarks(inputs)
	return ko_bookmarks(inputs)
});